import $ from "jquery";

let addToCart = $('.e-shop-button');
addToCart.append('<a class="add-to-cart-button" href="/panier"><span class="screen-reader-text">Panier</span></a>')